import React, { useState } from 'react';

import { uniqueId } from 'lodash';

import './ui-btn-loader.scss';

interface UiBtnLoaderProps {
  title?: string;
  onFileReady: (file: File) => void;
}

enum UiBtnLoaderStrings {
  TITLE = 'Выбрать файл',
}

const UiBtnLoader: React.FC<UiBtnLoaderProps> = ({ title, onFileReady }) => {
  const [inputId] = useState(uniqueId('file'));

  return (
    <div className="btn-loader">
      <div className="btn-loader__wrapper">
        <input
          onChange={(e) => {
            e.stopPropagation();
            if (e.target.files && e.target.files.length > 0) {
              onFileReady(e.target.files[0]);
            }
          }}
          className="btn-loader__input"
          type="file"
          accept="application/pdf"
          name="file"
          id={inputId}
        />
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label
          className="btn btn--sm btn--outline btn-loader__label"
          htmlFor={inputId}
        >
          <span className="btn__text btn-loader__name">
            {title || UiBtnLoaderStrings.TITLE}
          </span>
        </label>
      </div>
    </div>
  );
};

export default UiBtnLoader;
